import React from 'react'
import { Location } from './components/Location'
import { PresbiteryHistory } from './components/PresbiteryHistory'

export const AboutUs = () => {
  return (
    <div className="bg-light min-vh-100">
      {/* --- Encabezado de Sección --- */}
      <div className="py-5 bg-white shadow-sm border-bottom">
        <div className="container text-center">
          <h1 className="display-4 fw-bold text-primary mb-3">Conócenos</h1>
          <p className="text-muted lead">Nuestras raíces y nuestra presencia actual en el estado.</p>
        </div>
      </div>

      <div className="container mt-n4"> {/* Margen negativo para solapar un poco el control */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            
            {/* --- Navegación Estilizada (Memoria Visual) --- */}
            <ul className="nav nav-pills nav-fill p-2 bg-white rounded-pill shadow-sm mb-5 border" id="aboutTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button 
                  className="nav-link active rounded-pill py-3 d-flex align-items-center justify-content-center gap-2" 
                  id="history-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#history-pane" 
                  type="button" 
                  role="tab"
                >
                  <i className="bi bi-journal-bookmark-fill fs-5"></i>
                  <span className="fw-bold">Nuestra Historia</span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button 
                  className="nav-link rounded-pill py-3 d-flex align-items-center justify-content-center gap-2" 
                  id="location-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#location-pane" 
                  type="button" 
                  role="tab"
                >
                  <i className="bi bi-geo-alt-fill fs-5"></i>
                  <span className="fw-bold">Ubicaciones</span>
                </button>
              </li>
            </ul>

          </div>
        </div>

        {/* --- Contenido --- */}
        <div className="tab-content pb-5" id="aboutTabContent">
          <div 
            className="tab-pane fade show active animate__animated animate__fadeIn" 
            id="history-pane" 
            role="tabpanel" 
            aria-labelledby="history-tab" 
            tabIndex="0"
          >
            <div className="bg-white rounded-4 shadow-sm p-2">
               <PresbiteryHistory />
            </div>
          </div>

          <div 
            className="tab-pane fade animate__animated animate__fadeIn" 
            id="location-pane" 
            role="tabpanel" 
            aria-labelledby="location-tab" 
            tabIndex="0"
          >
            <div className="bg-white rounded-4 shadow-sm p-2">
              <Location />
            </div>
          </div>
        </div>
      </div>

      {/* --- CSS Adicional --- */}
      <style>{`
        .nav-pills .nav-link {
          color: #6c757d;
          transition: all 0.3s ease;
        }
        .nav-pills .nav-link.active {
          background-color: #0d6efd;
          box-shadow: 0 4px 15px rgba(13, 110, 253, 0.3);
        }
        .nav-pills .nav-link:hover:not(.active) {
          background-color: #f8f9fa;
          color: #0d6efd;
        }
        .mt-n4 {
          margin-top: -2.5rem !important;
        }
      `}</style>
    </div>
  )
}